/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type CommentContainer_story = {
    readonly id: string;
    readonly url: string;
    readonly isClosed: boolean;
    readonly canModerate: boolean;
    readonly settings: {
        readonly mode: STORY_MODE;
    };
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_story" | "EditCommentFormContainer_story" | "PermalinkButtonContainer_story" | "ReplyCommentFormContainer_story" | "UserTagsContainer_story">;
    readonly " $refType": "CommentContainer_story";
};
export type CommentContainer_story$data = CommentContainer_story;
export type CommentContainer_story$key = {
    readonly " $data"?: CommentContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClosed",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canModerate",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CaretContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditCommentFormContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PermalinkButtonContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyCommentFormContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '46a86d73d9a03870ae40488036d67f84';
export default node;
